import React, { Component } from "react";
import { Form, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { PiEye, PiInfo } from "react-icons/pi";
import { toast } from "react-toastify";
import axios from "../../axios";
import axiosLib from "axios";
import apiError from "../../error";
import { getDate } from "../../function";
import simulationandtrain from "../../assets/create_campaign/simulationandtrain.png";
import "../launch-modal/steps/steps.css";
import "./ai-template-selection.css";

const getCancelSource = () => {
	const CancelToken = axiosLib.CancelToken;
	return CancelToken ? CancelToken.source() : null;
};

/** Normalize API/parent values; avoids !!\"false\" === true. */
const coerceCredentialHarvesting = (raw) => {
	if (raw === true || raw === false) return raw;
	if (raw === 1 || raw === 0) return raw === 1;
	if (typeof raw === "string") {
		const s = String(raw).trim().toLowerCase();
		if (s === "true" || s === "1" || s === "yes" || s === "on") return true;
		if (s === "false" || s === "0" || s === "no" || s === "off" || s === "") return false;
	}
	return undefined;
};

const pickCredentialHarvestingRaw = (obj) => {
	if (!obj || typeof obj !== "object") return undefined;
	return obj.credential_harvesting ?? obj.credentialHarvesting;
};

/** Prefer full multi-select ids from parent; fallback to single selectedCategory (legacy). */
function categoryIdsFromProps(props) {
	if (Array.isArray(props.selectedCategoryIds) && props.selectedCategoryIds.length > 0) {
		return [...props.selectedCategoryIds];
	}
	if (props.selectedCategory != null && props.selectedCategory !== "") {
		return [props.selectedCategory];
	}
	return [];
}


export default class AiTemplateSelection extends Component {
	constructor(props) {
		super(props);
		this.categoriesCancel = null;
		this.templatesCancel = null;
		this.simulationCancel = null;
		const initialCatIds = categoryIdsFromProps(props);
		this.state = {
			loading: true,
			categories: [],
			selectedCategory: initialCatIds[0] || "",
			selectedCategoryIds: initialCatIds,
			templates: [],
			templatePath: "",
			templateMode: props.templateMode || "single",
			selectedTemplateId: props.templateId || null,
			selectedTemplateIds: Array.isArray(props.selectedTemplateIds) ? props.selectedTemplateIds : [],
			templateSearchInput: "",
			// Fetched from simulation when props are empty (follow-up flow)
			fetchedAttackType: "",
			fetchedSimulationType: "",
			fetchedCredentialHarvesting: false,
			fetchedTargetInteractionType: "",
			fetchedIsAIbased: false,
		};
	}

	getAttackType = () => this.props.attackType || this.state.fetchedAttackType;
	getSimulationType = () => this.props.simulationType || this.state.fetchedSimulationType;
	getCredentialHarvesting = () => {
		const cd = this.props.campaignDetails?.credentialHarvesting;
		if (cd !== undefined && cd !== null) {
			return coerceCredentialHarvesting(cd) ?? false;
		}
		const p = this.props.credentialHarvesting;
		if (p !== undefined && p !== null) {
			return coerceCredentialHarvesting(p) ?? false;
		}
		return coerceCredentialHarvesting(this.state.fetchedCredentialHarvesting) ?? false;
	};
	/** Prefer campaign details when set; blank string is treated as unset. For mode-based vectors, derive from isAIbased when tit is missing. */
	getTargetInteractionType = () => {
		if(this.props.targetInteractionType) return this.props.targetInteractionType;
		const cd = this.props.campaignDetails;
		const fromCd = cd && cd.targetInteractionType;
		if (fromCd !== undefined && fromCd !== null) {
			const s = String(fromCd).trim();
			if (s) return s;
		}
		if (this.getAttackType() === "Vishing" || this.getAttackType() === "WhatsApp") {
			return this.getIsAIbased() ? "inbound" : "outbound";
		}
		const fetched = this.state.fetchedTargetInteractionType;
		if (fetched !== undefined && fetched !== null && String(fetched).trim() !== "") {
			return String(fetched).trim();
		}
		return "";
	};
	/** Prefer campaign details when boolean is defined; avoid !== null only (undefined was wrongly treated as “use details”). */
	getIsAIbased = () => {
		if(this.props.isAIbased) return this.props.isAIbased;
		const cd = this.props.campaignDetails;
		if (cd && cd.isAIbased !== undefined && cd.isAIbased !== null) {
			return !!cd.isAIbased;
		}
		return !!this.state.fetchedIsAIbased;
	};

	componentDidMount() {
		if (this.props.campaignId && this.props.simulationId) {
			this.fetchCampaignContext();
		} else {
			this.loadCategories();
		}
	}

	componentWillUnmount() {
		if (this.categoriesCancel) this.categoriesCancel();
		if (this.templatesCancel) this.templatesCancel();
		if (this.simulationCancel) this.simulationCancel();
	}

	fetchCampaignContext = () => {
		const { campaignId, simulationId } = this.props;
		if (!campaignId || !simulationId) return;
		if (this.simulationCancel) this.simulationCancel();
		const source = getCancelSource();
		if (source) this.simulationCancel = source.cancel;
		axios.get("/api/simulation/", {
			params: { campaignId, simulationId },
			cancelToken: source ? source.token : undefined
		})
			.then((res) => {
				if (res.data?.simulation?.campaign) {
					const sim = res.data.simulation;
					const camp = sim.campaign;
					const attackType = camp.attack_type?.name || "";
					const simulationType = (camp.simulation_type?.name || "").trim();
					const chRaw =
						pickCredentialHarvestingRaw(camp) ?? pickCredentialHarvestingRaw(sim);
					const credentialHarvesting = coerceCredentialHarvesting(chRaw) ?? false;
					const targetInteractionType = camp.targetInteractionType || sim.targetInteractionType || "";
					const fetchedIsAIbased = !!(camp.isAIbased ?? sim.isAIbased);
					this.setState(
						{
							fetchedAttackType: attackType,
							fetchedSimulationType: simulationType,
							fetchedCredentialHarvesting: credentialHarvesting,
							fetchedTargetInteractionType: targetInteractionType,
							fetchedIsAIbased,
						},
						() => this.loadCategories()
					);
				} else {
					this.loadCategories();
				}
			})
			.catch((err) => {
				if (!axiosLib.isCancel(err)) this.setState({ loading: false });
				this.loadCategories();
			});
	};

	componentDidUpdate(prevProps) {
		console.log("the this .props inside ai template selection: ", this.props);
		// Load when filter props change
		if (prevProps.simulationType !== this.props.simulationType ||
			prevProps.attackType !== this.props.attackType ||
			prevProps.credentialHarvesting !== this.props.credentialHarvesting ||
			prevProps.campaignDetails?.credentialHarvesting !== this.props.campaignDetails?.credentialHarvesting) {
			this.loadCategories();
			return;
		}
		if (prevProps.campaignDetails?.targetInteractionType !== this.props.campaignDetails?.targetInteractionType ||
			prevProps.campaignDetails?.isAIbased !== this.props.campaignDetails?.isAIbased) {
			this.loadCategories();
			return;
		}
		// Load when attackType or simulationType becomes available (e.g. async from parent) and we haven't loaded yet
		const filterNowAvailable = (!prevProps.attackType && this.props.attackType) || (!prevProps.simulationType && this.props.simulationType);
		if (filterNowAvailable && this.state.categories.length === 0 && !this.state.loading) {
			this.loadCategories();
		}
		const prevCamp = prevProps.campaignId;
		const nextCamp = this.props.campaignId;
		const prevSim = prevProps.simulationId;
		const nextSim = this.props.simulationId;
		if ((prevCamp !== nextCamp || prevSim !== nextSim) && nextCamp && nextSim) {
			this.fetchCampaignContext();
		}

		if (prevProps.templateId !== this.props.templateId) {
			this.setState({ selectedTemplateId: this.props.templateId || null });
		}
		// Sync selection from parent when user navigates back (e.g. from Preview) so step reflects current state
		const prevIds = Array.isArray(prevProps.selectedTemplateIds) ? prevProps.selectedTemplateIds : [];
		const nextIds = Array.isArray(this.props.selectedTemplateIds) ? this.props.selectedTemplateIds : [];
		const idsEqual = prevIds.length === nextIds.length && nextIds.every((id, i) => id === prevIds[i]);
		if (!idsEqual || prevProps.templateId !== this.props.templateId) {
			this.setState({
				selectedTemplateId: this.props.templateId || null,
				selectedTemplateIds: nextIds.length ? [...nextIds] : []
			});
		}
		// Sync category filters when parent updates (e.g. navigate back to this step). Parent keeps full selectedCategoryIds array.
		const prevCatIds = categoryIdsFromProps(prevProps);
		const nextCatIds = categoryIdsFromProps(this.props);
		const categoryPropChanged =
			prevCatIds.length !== nextCatIds.length ||
			nextCatIds.some((id, i) => id !== prevCatIds[i]);
		const templateModePropChanged = prevProps.templateMode !== this.props.templateMode;
		if (categoryPropChanged || templateModePropChanged) {
			if (categoryPropChanged) {
				const ids = nextCatIds;
				const newCategory = ids[0] || "";
				this.setState({
					selectedCategory: newCategory,
					selectedCategoryIds: ids,
					templateMode: this.props.templateMode || "single",
					selectedTemplateIds: Array.isArray(this.props.selectedTemplateIds) ? this.props.selectedTemplateIds : []
				}, () => this.loadTemplates());
			} else if (templateModePropChanged) {
				this.setState({
					templateMode: this.props.templateMode || "single",
					selectedTemplateIds: Array.isArray(this.props.selectedTemplateIds) ? this.props.selectedTemplateIds : []
				});
			}
		}
	}
	loadTemplates = (categoryIdsOverride, options = {}) => {
		const ids = categoryIdsOverride !== undefined ? (Array.isArray(categoryIdsOverride) ? categoryIdsOverride : [categoryIdsOverride]) : this.state.selectedCategoryIds;
		const search = (this.state.templateSearchInput || "").trim();

		if (this.templatesCancel) {
			this.templatesCancel();
			this.templatesCancel = null;
		}
		const source = getCancelSource();
		if (source) this.templatesCancel = source.cancel;
		this.setState({ loading: true });
		const params = {
			type: "My Templates",
			attackType: this.getAttackType() ?? "",
			credentialHarvesting: this.getCredentialHarvesting(),
			simulationType: this.getSimulationType() ?? "",
			targetInteractionType: this.getTargetInteractionType(),
			isAIbased: this.getIsAIbased()
		};
		if (ids && ids.length > 0) params.categoryIds = ids;
		if (search) params.search = search;
		axios.get('/api/campaign/template/template', {
			params,
			cancelToken: source ? source.token : undefined
		})
			.then((res) => {
				let templates = res.data.campaign_template || [];
				const templatePath = res.data.path || "";
				// Launch from template preview / edit: show only the current template, not the full category list
				if (this.props.readOnly) {
					const raw =
						this.props.campaignTemplateId != null && this.props.campaignTemplateId !== ""
							? this.props.campaignTemplateId
							: this.props.templateId;
					const lockId = raw != null && raw !== "" ? parseInt(raw, 10) : NaN;
					if (!Number.isNaN(lockId)) {
						const matched = templates.filter((t) => t.id === lockId);
						if (matched.length > 0) {
							templates = matched;
						}
					}
				}
				this.setState({
					loading: false,
					templates,
					templatePath,
					...(!options.preserveSelection && templates.length <= 1 && this.state.templateMode === "random"
						? { templateMode: "single", selectedTemplateIds: [] }
						: {})
				}, () => {
					// Refresh parent selectedTemplates after templates load so Preview stays in sync
					if (!options.preserveSelection) this.updateData();
				});
			})
			.catch((error) => {
				if (!axiosLib.isCancel(error)) {
					this.setState({ loading: false, templates: [] });
					apiError(error);
				}
			});
	};

	loadCategories = () => {
		const attackType = this.getAttackType();
		const simulationType = this.getSimulationType();
		if (!attackType && !simulationType) return;

		if (this.categoriesCancel) {
			this.categoriesCancel();
			this.categoriesCancel = null;
		}
		const source = getCancelSource();
		if (source) this.categoriesCancel = source.cancel;
		this.setState({ loading: true });
		axios.get('/api/campaign/template/categories', {
			params: {
				type: "My Templates",
				attackType: attackType ?? "",
				credentialHarvesting: this.getCredentialHarvesting(),
				simulationType: simulationType ?? "",
				targetInteractionType: this.getTargetInteractionType(),
				isAIbased: this.getIsAIbased()
			},
			cancelToken: source ? source.token : undefined
		})
			.then((res) => {
				const categories = res.data.template_category || [];
				this.setState({ loading: false, categories }, () => {
					const ids = categoryIdsFromProps(this.props);
					this.setState({ selectedCategoryIds: ids, selectedCategory: ids[0] || "" }, () => this.loadTemplates());
				});
			})
			.catch((error) => {
				if (!axiosLib.isCancel(error)) {
					this.setState({ loading: false, categories: [] });
					apiError(error);
				}
			});
	};

	handleCategoryChange = (e) => {
		const value = e.target.value;
		const ids = value === "" ? [] : [value];
		this.setState({
			selectedCategory: value,
			selectedCategoryIds: ids,
			selectedTemplateId: null,
			selectedTemplateIds: []
		}, () => {
			this.loadTemplates();
			this.updateData();
		});
	};

	handleCategoryAllToggle = () => {
		this.setState({
			selectedCategoryIds: [],
			selectedCategory: "",
			selectedTemplateId: null,
			selectedTemplateIds: []
		}, () => {
			this.loadTemplates();
			this.updateData();
		});
	};

	handleCategoryToggle = (catId) => {
		const ids = this.state.selectedCategoryIds || [];
		const isSelected = ids.includes(catId);
		const newIds = isSelected ? ids.filter((id) => id !== catId) : [...ids, catId];
		this.setState({
			selectedCategoryIds: newIds,
			selectedCategory: newIds[0] || "",
			selectedTemplateId: null,
			selectedTemplateIds: []
		}, () => {
			this.loadTemplates();
			this.updateData();
		});
	};

	handleTemplateModeChange = (mode) => {
		const canUseMultiple = (this.state.templates || []).length > 1;
		if (mode === "random" && !canUseMultiple) return;
		this.setState({
			templateMode: mode,
			selectedTemplateId: null,
			selectedTemplateIds: []
		}, () => this.updateData());
	};

	handleTemplateSelect = (templateId) => {
		if (this.state.templateMode === "single") {
			this.setState({ selectedTemplateId: templateId }, () => this.updateData());
		} else {
			const currentIds = this.state.selectedTemplateIds || [];
			const isSelected = currentIds.includes(templateId);
			const newIds = isSelected
				? currentIds.filter(id => id !== templateId)
				: [...currentIds, templateId];
			this.setState({ selectedTemplateIds: newIds }, () => this.updateData());
		}
	};

	handleTemplateSearchChange = (e) => {
		const value = e.target.value;
		this.setState({ templateSearchInput: value }, () => {
			this.loadTemplates(undefined, { preserveSelection: true });
		});
	};

	/** Builds the list of selected templates from current state (id + display info). */
	getSelectedTemplates = () => {
		const { templateMode, selectedTemplateId, selectedTemplateIds, templates, templatePath } = this.state;
		let selectedTemplates = [];
		if (templateMode === "single" && selectedTemplateId) {
			const t = templates.find((tpl) => tpl.id === selectedTemplateId);
			if (t) {
				selectedTemplates = [
					{
						id: t.id,
						name: t.name,
						thumbnail: t.template?.thumbnail,
						thumbnailUrl: t.template?.thumbnailUrl,
						templatePath: templatePath
					}
				];
			}
		} else if (templateMode === "random" && selectedTemplateIds.length > 0) {
			selectedTemplates = selectedTemplateIds.map((id) => {
				const t = templates.find((tpl) => tpl.id === id);
				return t
					? {
							id: t.id,
							name: t.name,
							thumbnail: t.template?.thumbnail,
							thumbnailUrl: t.template?.thumbnailUrl,
							templatePath: templatePath
						}
					: { id, name: "Template" };
			});
		}
		return selectedTemplates;
	};

	updateData = () => {
		if (!this.props.onUpdate) return;
		let { templateMode, selectedTemplateId, selectedTemplateIds, templates } = this.state;

		// After filters/categories reload, drop ids that are no longer in the list so preview/parent stay in sync.
		if (templates.length > 0) {
			if (templateMode === "single" && selectedTemplateId != null && !templates.some((tpl) => tpl.id === selectedTemplateId)) {
				this.setState({ selectedTemplateId: null }, () => this.updateData());
				return;
			}
			if (templateMode === "random" && selectedTemplateIds.length > 0) {
				const nextIds = selectedTemplateIds.filter((id) => templates.some((tpl) => tpl.id === id));
				if (nextIds.length !== selectedTemplateIds.length) {
					this.setState({ selectedTemplateIds: nextIds }, () => this.updateData());
					return;
				}
			}
		}

		const idsForParent =
			templateMode === "single"
				? selectedTemplateId != null && selectedTemplateId !== ""
					? [selectedTemplateId]
					: []
				: selectedTemplateIds;

		const templateId =
			templateMode === "single"
				? selectedTemplateId
				: selectedTemplateIds.length > 0
					? selectedTemplateIds[0]
					: null;

		this.props.onUpdate({
			templateId,
			selectedCategory: this.state.selectedCategory,
			selectedCategoryIds: this.state.selectedCategoryIds,
			selectedTemplateIds: idsForParent,
			templateMode,
			selectedTemplates: this.getSelectedTemplates()
		});
	};

	validate = () => {
		const canUseMultiple = (this.state.templates || []).length > 1;
		if (this.state.templateMode === "single") {
			const hasSelection = this.state.selectedTemplateId != null && this.state.selectedTemplateId !== "";
			if (!hasSelection) {
				toast.error("Please select a template");
				return false;
			}
		} else {
			if (!canUseMultiple) {
				toast.error("Multiple mode is available only when more than one template is available");
				return false;
			}
			if (!this.state.selectedTemplateIds || this.state.selectedTemplateIds.length < 2) {
				toast.error("Please select at least two templates");
				return false;
			}
		}
		return true;
	};

	handleDone = () => {
		if (!this.validate()) return;
		if (this.props.onDone) {
			this.props.onDone(this.getSelectedTemplates());
		}
	};

	handleCreateTemplate = () => {
		if (!this.props.onCreateTemplate) return;
		// Pass the resolved attack-type / credential-harvesting context and current
		// selection so the template editor renders the correct surfaces.
		this.props.onCreateTemplate({
			attackType: this.getAttackType(),
			simulationType: this.getSimulationType(),
			credentialHarvesting: this.getCredentialHarvesting(),
			targetInteractionType: this.getTargetInteractionType(),
			isAIbased: this.getIsAIbased(),
		});
	};

	formatDate = (dateString) => {
		if (!dateString) return "";
		return getDate(dateString);
	};

	render() {
		const { categories, selectedCategoryIds, templates, loading, templateMode, selectedTemplateId, selectedTemplateIds, templateSearchInput } = this.state;
		const { readOnly } = this.props;
		const canUseMultiple = (templates || []).length > 1;
		const categoryLabel = selectedCategoryIds.length === 0
			? "All"
			: selectedCategoryIds.length === 1
				? (() => {
					const c = categories.find(cat => (cat.category?.id || cat.id) === selectedCategoryIds[0]);
					return c ? `${c.category?.name || c.name || ""} (${c.count != null ? c.count : 0} Templates)` : "All";
				})()
				: `${selectedCategoryIds.length} categories`;

		return (
			<div className="step-content-wrapper ai-template-selection">
				{
					!readOnly && (
						<div className={`template-selection-filters ${readOnly ? "read-only" : ""}`} style={readOnly ? { pointerEvents: "none", opacity: 0.9 } : {}}>
					<div className="ai-filter-wrap"><div className="filter-row">
						<Form.Group className="filter-group">
							<Form.Label className="filter-label">Filter By</Form.Label>
							<Dropdown className="category-filter-dropdown">
								<Dropdown.Toggle variant="secondary" id="category-filter-dropdown" className="filter-select category-dropdown-toggle">
									Category: {categoryLabel}
								</Dropdown.Toggle>
								<Dropdown.Menu className="category-multiselect-menu">
									<Dropdown.Item
										as="div"
										className="category-filter-item"
										onClick={(e) => { e.preventDefault(); this.handleCategoryAllToggle(); }}
									>
										<Form.Check
											type="checkbox"
											id="category-filter-all"
											label="All"
											checked={selectedCategoryIds.length === 0}
											onChange={this.handleCategoryAllToggle}
											onClick={(e) => e.stopPropagation()}
										/>
									</Dropdown.Item>
									{categories.map((cat, index) => {
										const catId = cat.category?.id || cat.id;
										const label = `${cat.category?.name || cat.name || ""} (${cat.count != null ? cat.count : 0} Templates)`;
										return (
											<Dropdown.Item
												key={catId}
												as="div"
												className="category-filter-item"
												onClick={(e) => { e.preventDefault(); this.handleCategoryToggle(catId); }}
											>
												<Form.Check
													type="checkbox"
													id={`category-filter-${catId}`}
													label={label}
													checked={selectedCategoryIds.includes(catId)}
													onChange={() => this.handleCategoryToggle(catId)}
													onClick={(e) => e.stopPropagation()}
												/>
											</Dropdown.Item>
										);
									})}
								</Dropdown.Menu>
							</Dropdown>
						</Form.Group>
						<div className="filter-separator" />
						<Form.Group className="filter-group">
							<Form.Label className="template-mode-label">Template Mode</Form.Label>
							<div className="template-mode-options">
								<div
									className={`template-mode-option ${templateMode === "single" ? "selected" : ""}`}
									onClick={() => this.handleTemplateModeChange("single")}
								>
									<Form.Check
										type="radio"
										name="templateMode"
										onChange={() => this.handleTemplateModeChange("single")}
										label={
											<span className="template-mode-label-wrap">
												Single
												<OverlayTrigger
													placement="top"
													overlay={<Tooltip id="single-template-mode-tip">Uses one template for all users in the campaign.</Tooltip>}
												>
													<span className="template-mode-info-icon" onClick={(e) => e.stopPropagation()}>
														<PiInfo />
													</span>
												</OverlayTrigger>
											</span>
										}
										checked={templateMode === "single"}
									/>
								</div>
								<div className="filter-separator-in" />
								<div
									className={`template-mode-option ${templateMode === "random" ? "selected" : ""} ${!canUseMultiple ? "disabled" : ""}`}
									onClick={() => canUseMultiple && this.handleTemplateModeChange("random")}
								>
									<Form.Check
										type="radio"
										name="templateMode"
										onChange={() => this.handleTemplateModeChange("random")}
										label={
											<span className="template-mode-label-wrap">
												Random
												<OverlayTrigger
													placement="top"
													overlay={<Tooltip id="multiple-template-mode-tip">Distributes multiple selected templates randomly among users.</Tooltip>}
												>
													<span className="template-mode-info-icon" onClick={(e) => e.stopPropagation()}>
														<PiInfo />
													</span>
												</OverlayTrigger>
											</span>
										}
										checked={templateMode === "random"}
										disabled={!canUseMultiple}
									/>
								</div>
							</div>
						</Form.Group>
						<Form.Group className="template-search-group ms-2">
							<Form.Control
								type="search"
								className="template-search-input"
								placeholder="Search"
								value={templateSearchInput}
								onChange={this.handleTemplateSearchChange}
								aria-label="Search templates"
							/>
						</Form.Group>
					</div>
				</div></div>

					)
				}

				{loading ? (
					<div className="template-loading">Loading templates...</div>
				) : (
					<div className="template-grid">
						{templates.length > 0 ? (
							templates.map((template, index) => {
								const isSelected = templateMode === "single"
									? selectedTemplateId === template.id
									: selectedTemplateIds.includes(template.id);

								const thumbnailSrc = template.template?.thumbnailUrl
									? template.template.thumbnailUrl
									: simulationandtrain;

								return (
									<div
										key={index}
										className={`template-card ${isSelected ? "selected" : ""} ${readOnly ? "read-only" : ""}`}
										onClick={() => !readOnly && this.handleTemplateSelect(template.id)}
										 style={{filter: readOnly ? "grayscale(70%)" : "none", pointerEvents: readOnly ? "none" : "auto", opacity: readOnly ? 0.85 : 1}}
									>
										<div className="template-card-image">
											<img
												src={thumbnailSrc}
												alt={template.name || "Template thumbnail"}
												className="img-fluid"
											/>
											{template.simulation_type && (
												<div className="template-simulation-badge">
													{template.simulation_type.name}
												</div>
											)}
											{templateMode === "random" && (
												<div className="template-card-checkbox-wrapper">
													<Form.Check
														type="checkbox"
														checked={isSelected}
														onChange={(e) => {
															e.stopPropagation();
															this.handleTemplateSelect(template.id);
														}}
														onClick={(e) => e.stopPropagation()}
														className="template-card-checkbox-input"
													/>
												</div>
											)}
										</div>
										<div className="template-card-content">
											<div className="template-card-title-row">
												<h6 className="template-card-title">{template.name}</h6>
												<PiEye
													className="template-view-icon"
													onClick={(e) => {
														e.stopPropagation();
														if (this.props.onPreviewTemplate) this.props.onPreviewTemplate(template.id);
													}}
												/>
											</div>
											<p className="template-card-date">{this.formatDate(template.createdAt)}</p>
											<div className="template-card-tags">
												{template.attack_type && (
													<span className="template-tag-attack">{template.attack_type.name}</span>
												)}
												{template.simulation_type && (
													<span className="template-tag-category">{template.simulation_type.name}</span>
												)}
											</div>
										</div>
									</div>
								);
							})
						) : (
							templateSearchInput.trim() ? (
								<div className="template-empty">No templates found</div>
							) : selectedCategoryIds.length > 0 ? (
								<div className="template-empty">No templates found in this category.</div>
							) : (
								<div className="template-empty">Please select a category to view templates.</div>
							)
						)}
					</div>
				)}

				{!readOnly && (
					<div className="ai-template-footer">
						<button
							type="button"
							className="ai-template-done-btn"
							onClick={this.handleDone}
						>
							✓ Done
						</button>
						<button
							type="button"
							className="ai-template-create-btn"
							onClick={this.handleCreateTemplate}
						>
							+ Create Template
						</button>
					</div>
				)}
			</div>
		);
	}
}
